import { List, Popup } from 'antd-mobile';
import React from 'react';
import { useFlashcard, usePlaylist } from '../../zustand/handlers';
import { useCategoryList } from '../../zustand/requests';

function PlaylistPopUp({ swiperRef }) {
    const playlist = usePlaylist();
    const flashcard = useFlashcard();
    const categories = useCategoryList();
    const inspectionSteps = categories.data;
    let index = 0;
    return (
        <>
            <Popup
                visible={playlist.active}
                onMaskClick={() => {
                    playlist.deactivate();
                }}
                destroyOnClose
                position='left'
                bodyStyle={{ width: '60vw', overflow: "auto" }}
            >
                <div
                // className={styles.checkListContainer}
                >
                    {inspectionSteps?.map(({ title: category, name, flashcards: items }) => (
                        <List
                            style={{ backgroundColor: `var(--border-${name})` }} header={<div style={{
                                textAlign: 'center',
                                color: "var(--adm-color-text)",
                                // fontSize:'18px',
                                fontWeight: "bold",


                            }}>{category}</div>}>
                            {items?.map(({ title, ind = index }) => {

                                const onClick = () => {
                                    flashcard.setCurrent(index);
                                    playlist.deactivate();
                                    swiperRef.current.swipeTo(ind);
                                };
                                index++;
                                return (
                                    <List.Item onClick={onClick}
                                        style={{
                                            backgroundColor: `var(--bg-${name})`,
                                            borderColor: "black",
                                            border: `1px solid var(--border-${name})`,
                                        }}
                                    >
                                        {title}
                                    </List.Item>
                                )
                            })
                            }
                        </List>
                    ))}
                    {/* <CheckList
                        // className={styles.myCheckList}
                        defaultValue={[speed.value]}
                        onChange={val => {
                            const value = val[0];
                            speed.setValue(value)
                            speed.deactivate();
                            // setSelected(val[0])
                            // setVisible(false)

                        }}
                    >
                        {speed.list.map(({ value }) => (
                            <CheckList.Item key={value} value={value}>
                                {value}
                            </CheckList.Item>
                        ))}
                    </CheckList> */}
                </div>
            </Popup>
        </>
    )
}

export default PlaylistPopUp